module.exports = __webpack_public_path__ + "static/media/logo-ltrent-full.72142774.png";